import { Theme } from '@mui/material/styles'
export const getLocationCardStyles = (theme: Theme) => ({
  card: {
    padding: theme.spacing(0.8),
    width: '320px',
    lineHeight: '21px',
  },

  longCard: {
    padding: theme.spacing(0.8),
    width: '485px',
    lineHeight: '21px',
  },

  bold: { fontFamily: 'Source Sans Pro SemiBold' },
  moreBtn: { marginLeft: 'auto' },

  expandLink: {
    color: '#005AA3',
    cursor: 'pointer',
    width: 'maxcontent',
  },

  locationLink: {
    display: 'flex',
    alignItems: 'center',
  },

  image: { marginLeft: theme.spacing(0.2) },

  checkbox: {
    margin: `0 ${theme.spacing(2.1)} 0 auto`,
  },

  checkboxLabel: {
    fontSize: '12px',
  },

  actions: {
    display: 'flex',
    marginLeft: 'auto',
    flexDirection: 'column',
    flexShrink: 0,
  },

  icons: {
    marginRight: theme.spacing(0.8),
    width: '16px',
    height: '18px',
  },

  links: {
    marginTop: '4px',
  },

  linksNoMargin: {
    marginTop: '0px',
  },
})
